import { Pipe, PipeTransform } from '@angular/core';
import { AnessaTranslationService } from './anessa-translation.service';

@Pipe({
  name: 'anessaTranslation'
})
export class AnessaTranslationPipe implements PipeTransform {

  constructor(private translationService: AnessaTranslationService) {
  }

  /**
   * Fetches the word or phase for the provided translation ID. For the translations to be updated
   * when the language is changed, a trigger must be provided that changes when the language is updated.
   * The easiest way to do this is to provided the current selected language, setup a subscription
   * in the component that listens for the language changes notifier and updates the trigger with
   * the current language.
   * @param translationId the ID used in the translation JSON files.
   * @param trigger a string that is used to update the angular view with the most current
   * translation
   * @param params object containing parameters that might be needed for the current translation ID
   */
  transform(translationId: string | string[], trigger: any, params: {} = {}): string {
    return this.translationService.get(translationId, params);
  }

}
